import { createSelector } from 'reselect';
import { RootState } from 'reducers/rootReducer';

const getCondominiReducer = (state: RootState) => state.condominiReducer;

export const condominiReducerSelector = createSelector(getCondominiReducer, (res) => res);
export const condominiFilters = createSelector(getCondominiReducer, (res) => res.filters);
